import { Table } from '@tanstack/react-table';

import { createSafeContext } from '../../src/utils';
import { TableContext } from './types/types';

export const [TableProvider, useTableContext] = createSafeContext<TableContext<any, Table<any>>>(
  'Table component was not found in tree'
);
